<!-- signin.component.html -->


<div style="width: 300px; margin: 0 auto; padding: 20px; background-color: #f9f9f9; border-radius: 8px; box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);">
    <h1>Sign In with Microsoft</h1>
    <div style="margin-bottom: 20px;"></div>

    <button (click)="signIn()" style="width: 100%; padding: 10px; background-color: #007bff; color: #fff; border: none; border-radius: 4px; cursor: pointer; transition: background-color 0.3s;">SignIn</button>
        
</div>

